import {_WMSLayer as WMSLayer} from '@deck.gl/geo-layers/typed';
import { IWmsProps } from './DatasetMesh';
import Api from '../../../api/Api';
import { isEmpty } from 'underscore';

function createMeshUrl(props: IWmsProps){
  const endPoint = '/DHIWMS_CACHE/DHIWMSHandler.ashx?';
  const service = 'SERVICE=wms';
  const request = 'REQUEST=GetMap';
  const layer = 'LAYERS=' + props.layers;
  const style = 'STYLES=' + props.styles;
  const format = 'FORMAT=image/png';
  const version = 'VERSION=1.3.0';
  const transparent = 'TRANSPARENT=true';
  const sourceItem = 'SOURCEITEM=' + props.sourceItem;
  const sourceDate = 'SOURCEDATETIME=' + props.sourceDateTime;
  const width = 'WIDTH={width}';
  const height = 'HEIGHT={height}';
  const srs = 'SRS=EPSG:3857'; 
  const bbox =  'BBOX={east},{north},{west},{south}'

  return (
    endPoint +
    [
      service,
      request,
      layer,
      style,
      format,
      version,
      transparent,
      sourceItem,
      sourceDate,
      width,
      height,
      srs,
      bbox    
    ].join('&')
  );
}

export function MeshWMSLayer(props: IWmsProps) {
  if (isEmpty(props)) return null;

   const url = Api.MESH_DOMAIN + createMeshUrl(props) 

  const layer = new WMSLayer({  
    data: url, 
    serviceType: 'template',
  })
  return layer
}